<template>
    <div class="return">
         <div class="box">
             <div class="item">
                  <div class="left">投诉对象</div>
                  <div class="right right1">{{ dataItem.defendantName }}</div>
             </div>
             <div class="item">
                  <div class="left">投诉单号</div>
                  <div class="right">{{ dataItem.mainComplainNumber }}</div>
             </div>
             <div class="item">
                  <div class="left">投诉类型</div>
                  <div class="right">{{ dataItem.complainChannelValue }}</div>
             </div>
             <div class="item">
                  <div class="left">投诉时间</div>
                  <div class="right">{{ dataItem.complainTime }}</div>
             </div>
             <div class="item">
                  <div class="left">投诉人</div>
                  <div class="right">{{ dataItem.complainName }}</div>
             </div>
             <div class="item">
                  <div class="left">联系电话</div>
                  <div class="right">{{ dataItem.complainPhone }}</div>
             </div>
             <div class="reason line_bottom line_top">
                  <div class="left">退回原因</div>
                  <div class="right" @click="backReasons">
                        <span v-if="!selectValue || selectValue === ''">请选择</span>
                        <span v-else class="right_item">{{ selectValue }}</span>
                        <img src="../../../../assets/image/ic_lb_jt@3x.png"/>
                  </div>
             </div>
             <div class="reson_content line_top">
                  <div class="r_txt">原因详述</div>
                  <div class="r_content">
                    <!-- <textarea
                        class="markRemackBox"
                        v-model.trim="message"
                        @input="change"
                        placeholder="请详细描述退回原因"
                    ></textarea> -->
                    <van-field  
                        class="markRemackBox"
                        v-model.trim="message"
                        autosize
                        type="textarea"
                        maxlength="200"
                        placeholder="请详细描述退回原因"
                    />
                  </div>
             </div>
         </div>
         <div class="btns" @click="goHomePage" >
               <span :class="{'activeBtn': showBtn}">确认退回</span>
         </div>
        <toast ref="toast"></toast>
         <!-- 退回原因 -->
         <common-picker ref="commonPicker2" :typeList="detailList" :cols="colsDetail" @getTypeValue="typeListDetail"></common-picker>
    </div>
</template>
<script>
import commonPicker from '../../../../components/base/commonPicker';
import api from '../../../../service/modules/complaintApis';
import toast from '../components/toast';

export default {
    components: {
        commonPicker,
        toast
    },
    data () {
        return {
            selectValue: '',
            selectId: '',
            colsDetail: 1,
            message: '',
            detailList: [],
            dataList: {},
            dataItem: JSON.parse(this.$route.query.dataItem)
        }
    },
    created () {
        this.dataList = JSON.parse(localStorage.getItem('item'));
        console.log(this.dataList, '0000-----', this.dataItem.complainChannelValue)
        this.getReason();
    },
    computed: {
        showBtn () {
            if (this.selectValue && this.message.trim() !== '') {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        getReason () {
            let data = {
                data: {
                    type: '4'
                }
            }
            api.return.getReasonList(data).then(res=> {
                if (res.ret === 0) {
                    let data = res.data.list.map(item => {
                        return {
                            text: item.name,
                            value: item.id
                        }
                    })
                    this.detailList.push(data)
                }
            })
        },
        change () {
            this.message = this.message.replace(" ","");
        },
        // 唤起弹窗
        backReasons () {
            this.$refs.commonPicker2.showPicker();
        },

        // 切换数据
        typeListDetail (val) {
            this.selectValue = val[0].text;
            this.selectId = val[0].value;
        },

        goHomePage () {
            if (this.selectValue && this.message.trim() !== '') {
                if (this.message.length < 20) {
                    this.$Toast('原因详述字数为20-200字');
                    return;
                }
                let params = {
                    mainComplainNumber: this.dataList.mainComplainNumber,
                    subId: this.dataList.subId,
                    complain12301Number: this.dataList.complain12301Number,
                    clause: this.selectId,
                    note: this.message
                }
                api.return.rollback(params).then(res => {
                    if (res.ret === 0) {
                        this.$refs.toast.showToast();
                        setTimeout(() => {
                            yyn.invokeJSB('closeWindow');
                        }, 1500)
                        // this.$Toast({
                        //     message: '处理成功',
                        //     icon: 'passed'
                        // });
                    }
                })
            }
        }
    }
}
</script>
<style lang="less" scoped>
.return{
    width:100%;
    height:100%;
    .box{
        width:100%;
        height:100%;
        padding:0 12px;
        box-sizing: border-box;
        .item{
            width:100%;
            display: flex;
            flex-direction: row;
            align-content: center;
            align-items:flex-start;
            font-size:14px;
            margin-top:16px;
            .left{
                color:#999;
                width:60px;
            }
            .right{
                color:#333;
                flex:1;
                margin-left:27px;
            }
            .right1{
                line-height: 1.3em;
            }
        }
        .reason{
            width:100%;
            padding:16px 0;
            display: flex;
            flex-direction: row;
            align-content: center;
            justify-content: space-between;
            margin-top:16px;
            .left{
                color:#666666;
                font-size:14px;
            }
            .right{
                display: flex;
                flex-direction: row;
                align-content: center;
                justify-content: space-between;
                span{
                    font-size:14px;
                    color:#CCCCCC;
                }
                img{
                    width:12px;
                    height:12px;
                }
                .right_item {
                    color:#333;
                }
            }
        }
        .reson_content{
            width:100%;
            .r_txt{
                padding-top:16px;
                font-size:14px;
                color:#666666;
            }
            .r_content{
                width:100%;
                height:120px;
                margin-top:12px;
                textarea{
                    width:100%;
                    height:100%;
                    border:0;
                    outline: none;
                    background-color: #F5F5F5;
                    border-radius: 3px;
                    font-size:14px;
                    padding:14px 12px 0 12px;
                    box-sizing: border-box;
                }
                .markRemackBox{
                    width:100%;
                    border:0;
                    padding:16px;
                    box-sizing: border-box;
                    outline: none;
                    background-color: #F9F9F9;
                    min-height:180px;
                    border-radius: 3px;
                    font-size:14px;
                    font-weight: 400;
                    color: #333;
                    line-height: 18px;
                }
            }
        }
    }
    .btns{
        width:100%;
        height:60px;
        position: fixed;
        left:0;
        bottom:0;
        z-index: 2;
        background-color: #fff;
        padding:10px 12px;
        box-shadow:5px 5px 10px rgba(0,0,0,0.5);
        span{
            display: inline-block;
            width:100%;
            height:100%;
            background-color: #9bd9ba;
            color:#fff;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            font-size:16px;
        }
        .activeBtn {
            background-color: #36b374;
        }
    }
}

</style>